module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"pendingHeadline":"Your import is in progress","pendingMessage":"You\u0027ll be notified as soon as it\u0027s complete."}}')
  delete Component.options._Ctor
}
